import { render, staticRenderFns } from "./UserActionsPage.vue?vue&type=template&id=62cf2f64&"
import script from "./UserActionsPage.vue?vue&type=script&lang=js&"
export * from "./UserActionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports